import { useDispatch, useSelector } from '@redux';
import { Button, Form, Input, Modal } from 'antd';
import { RestInputContext } from 'components/form/RestInputContext';
import { DynamicObjectType } from 'core/types/common';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SelectCustom from '../VNCitySelector/SelectCustom';
import { ORDER_FAILQC_REASONS } from 'constants/constants';
import { failQC } from '@redux/orders/actions';
import FormUpload from 'components/form/FormUpload';
import { get } from 'lodash';

const FailQCModal = ({ onCancel }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const modal = useSelector<DynamicObjectType>((state) => state.modal.modal);
  const currentData = useSelector<DynamicObjectType>(
    (state) => state.orders.currentData,
  );

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      setLoading(true);
      dispatch(
        failQC({
          data: {
            id: currentData?.id,
            data: values,
          },
        }),
      )
        .then((res: DynamicObjectType) => {
          if (res?.payload?.success) {
            onCancel();
            setLoading(false);
            window.location.reload();
          }
        })
        .then(() => setLoading(false));
    });
  };

  return (
    <Modal
      open={modal?.failQC?.isOpen}
      onCancel={onCancel}
      footer={null}
      width={443}
      closeIcon={false}
      closable={false}
      title={t('orderStatus.failQC')}
    >
      <div className="grid gap-5">
        <RestInputContext.Provider value={{ form }}>
          <Form form={form} onFinish={handleSubmit} layout="vertical">
            <SelectCustom
              source="failQCReason"
              resourceData={ORDER_FAILQC_REASONS}
              valueProp="value"
              titleProp="text"
              required
              header={t('orders.cancelReason')}
            />
            <Form.Item name="failQCNote" label="Note">
              <Input.TextArea />
            </Form.Item>
            <Form.Item
              noStyle
              shouldUpdate={(o, n) => {
                return get(o, 'failQCImages') !== get(n, 'failQCImages');
              }}
            >
              {({ getFieldValue }) => {
                const value = getFieldValue('failQCImages');
                return (
                  <FormUpload
                    // formatHightLight={formatHightLight}
                    name="failQCImages"
                    label={t('ordersReturn.image')}
                    // highlightName="avatar"
                    accept="image/*"
                    form={form}
                    value={value}
                    type="array"
                  />
                );
              }}
            </Form.Item>
            <div className="flex justify-end items-center gap-2.5">
              <Button className="h-[40px] w-[100px]" onClick={onCancel}>
                {t('button.cancel')}
              </Button>
              <Button
                className="h-[40px] w-[100px]"
                type="primary"
                htmlType="submit"
                loading={loading}
              >
                {t('button.ok')}
              </Button>
            </div>
          </Form>
        </RestInputContext.Provider>
      </div>
    </Modal>
  );
};

export default FailQCModal;
